import { Card } from '../../../../components/Cards';
import Input from '../../../../components/Input';
import { getName, getSubdomain, setName } from '../model';
import { ModelProps } from '../presenter';
import SettingsRow from './SettingsRow';

const CompanySettings = ({ model, setModel }: ModelProps) => {
    return (
        <div>
            <Card>
                <SettingsRow label="Company Name">
                    <Input
                        value={getName(model)}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setModel(setName(e.target.value, model))}
                        autocomplete="off"
                    />
                </SettingsRow>
                <SettingsRow label="Subdomain">
                    {getSubdomain(model) ? (
                        <p>https://{getSubdomain(model)}.small-improvements.com</p>
                    ) : (
                        <>
                            <p>No subdomain configured</p>
                            <p className="caption">
                                Reach out to our <a href="mailto:support@small-improvements.com">Support team</a> to
                                request a subdomain like (e.g. https://mycompany.small-improvements.com)
                            </p>
                        </>
                    )}
                </SettingsRow>
            </Card>
        </div>
    );
};

export default CompanySettings;
